import { render } from "./CreateDogDialog.vue?vue&type=template&id=2f626564"
import script from "./CreateDogDialog.vue?vue&type=script&lang=js"
export * from "./CreateDogDialog.vue?vue&type=script&lang=js"

import exportComponent from "C:\\stuff\\dfob\\adminui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__